import { render, staticRenderFns } from "./SubOne.vue?vue&type=template&id=3fee22d7&"
import script from "./SubOne.vue?vue&type=script&lang=js&"
export * from "./SubOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports